
// import "../SecurityPermission.scss";
import BaseComponent from "../../shared/baseComponent";
import "../securityPermission/SecurityPermission.scss";
 
import FormFieldGroup from "../../components/UI Element/FormGrop/FormFieldGroup";

import modulePermissionServices from "../../services/domainServices/modulePermissionServices";
import SecurityPermissionList from "../securityPermission/SecurityPermissionList";
import { GetPermissionData } from "../securityPermission/GenarateTreeData";
import { getAuthProps } from "../../utils/AuthenticationLibrary";

export default class ModulePermission extends BaseComponent {

  //** Constructor  and Component method */
  constructor(props) {
    super(props);
    this.modulePermissionServices = new modulePermissionServices();
    this.userId =getAuthProps();
    this.selectedModule = null;
    this.state = {
      ...this.state,
      formData: this.modulePermissionServices.dataItem,
      setRoleList: [],
      setModuleList: [],    
      setSubModuleList: [], 
      setIsLoad: false,
      selectedId: null,
      selectedRoleId : null,
      selectedModuleId:null,
      selectedSubModuleId : null,
      permissionItem: [],
      setModelshow: false,
      setPermissionTreeData: [],
      
    };
    this.onPermissionItemSet = this.onPermissionItemSet.bind(this);
    this.modulePermissionServices.onUpdateState = this.updateState.bind(this);
    this.handleClick = this.handleClick.bind(this);
     this.handleSavePermission = this.handleSavePermission.bind(this);
  }

  componentDidMount() {

      this.modulePermissionServices.onGetRoles();
      this.modulePermissionServices.onGetModules();
     // this.modulePermissionServices.onGetSubModules();
  }


  handleChange(name, value) {
    const newValue = parseInt(value);
    if (name === "roleId" || name === "moduleId" || "submoduleId") {
      let detail = this.state.formData;
      detail[name] = newValue;
      this.setState({ formData: { ...detail } });
      this.setState({ setModelshow: false });
      this.setState({ selectedId: newValue });

       if(name === "roleId"){
          this.setState({ selectedRoleId : newValue })
       }
       if(name === "submoduleId"){
          this.setState({selectedSubModuleId: newValue })
       }
      if (name === "moduleId") {
        
        this.selectedModule = this.state.setModuleList.find(
          (item) => item.id === newValue
        );
          this.modulePermissionServices.onGetSubModules(newValue);
      }
    }
  }

  handleSavePermission() {
    
    if (this.state.permissionItem && this.state.permissionItem.length > 0) {
      let permissionSettingList = GetPermissionData(this.state.permissionItem);
      const transformedData = permissionSettingList.map((item) => ({
        securitySettingId: item.securitySettingId,
        securityKeyId: item.securityKeyId,
        roleId: item.roleId,
      }));
      const requestData = {
        securityPermissionsList: transformedData,
        createdBy: this.userId ?this.userId.Userid: 0,
      };
      this.modulePermissionServices.onSavePermission(requestData);
    }
  }


  onPermissionItemSet(permissionTreeItem) {
    this.setState({ permissionItem: permissionTreeItem });
  }

  handleClick() {
    if (this.state.selectedRoleId ) {
      if (this.selectedModule?.isSubModuleExist && !this.state.selectedSubModuleId) {
        this.modulePermissionServices.apiService.serviceManager.swalServices.WarningToaster(
          "Please select a SubModule to proceed."
        );
        return; 
      }
      this.setState({ setModelshow: true });
      let request = [
         this.state.selectedRoleId,
         this.selectedModule?.isSubModuleExist ? this.state.selectedSubModuleId : 0,
         this.selectedModule.id,
      ]
      this.modulePermissionServices.onShowSecurity(request);
    } else {
      this.modulePermissionServices.apiService.serviceManager.swalServices.WarningToaster("Please choose a Role , SubModule to proceed.");
    }
  }

  //** Render Method  */
  render() {
    return (
      <>
        <div>
          <div className="accordion mb-3" id="accordionExample">
            <div className="card accordion-item active">
              <div id="accordionOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex security-dropdowns">
                        {this.modulePermissionServices.formFields.map((Item, index) => {
                          return (
                            <>
                            {Item.fieldName === "roleId" ?
                             (
                            <FormFieldGroup
                                className="col-md-3"
                                column={Item}
                                value={this.state.formData[Item.fieldName] ? this.state.formData[Item.fieldName] : ""}
                                options={this.state.setRoleList}
                                onChange={(event) =>
                                  this.handleChange(Item.fieldName, event.target.value)
                                }
                                key={index}
                               />) : null}
                            {Item.fieldName === "moduleId" ?
                             (
                            <FormFieldGroup
                                className="col-md-3"
                                column={Item}
                                value={this.state.formData[Item.fieldName] ? this.state.formData[Item.fieldName] : ""}
                                options={this.state.setModuleList}
                                onChange={(event) =>
                                  this.handleChange(Item.fieldName, event.target.value)
                                }
                                key={index}
                               />) : null}
                               { this.selectedModule?.isSubModuleExist === true &&  Item.fieldName === "submoduleId" ?
                             (
                            <FormFieldGroup
                                className="col-md-3"
                                column={Item}
                                value={this.state.formData[Item.fieldName] ? this.state.formData[Item.fieldName] : ""}
                                options={this.state.setSubModuleList}
                                onChange={(event) =>
                                  this.handleChange(Item.fieldName, event.target.value)
                                }
                                key={index}
                               />) : null}
                            </>
                          );
                        })}
                      </div>
                      <div className="button-sec">
                        <button className="tab-title btn-hover color-3 active security-show-button" onClick={this.handleClick} >
                          Show Permission
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
    
          {this.state.setModelshow === true ?
            <>
              <div className="accordion" id="accordionExample">
                <div className="card accordion-item active">
                  <div id="accordionOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      <div className="card-body">
              <div className="security-save-button">
                <button className="tab-title btn-hover color-3 active" onClick={this.handleSavePermission}>
                  Save Permission
                </button>
              </div>
              <SecurityPermissionList subModuleId={this.state.selectedSubModuleId} setIsLoad={this.state.setIsLoad}
                onPermissionSet={this.onPermissionItemSet} permissionTreeData={this.state.setPermissionTreeData} />
              </div>
                    </div>
                  </div>
                </div>
              </div>
            </> : null}
        </div>
      </>
    );
  }
   
}

